import {
    Grid,
    Card,
    CardContent,
    Typography,
    Box,
    Avatar,
    Chip,
    Divider,
} from '@mui/material';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';

function StatistikenTab({ stats }) {
    return (
        <Card>
            <CardContent>
                <Box display="flex" alignItems="center" mb={2}>
                    <Avatar sx={{ bgcolor: 'success.main', mr: 2 }}>
                        <EmojiEventsIcon />
                    </Avatar>
                    <Typography variant="h6">Gruppen-Highscores</Typography>
                </Box>
                <Divider sx={{ mb: 2 }} />
                {stats?.gruppenHighscores?.length > 0 ? (
                    <Grid container spacing={2}>
                        {stats.gruppenHighscores.map((h, idx) => (
                            <Grid key={idx}>
                                <Card variant="outlined" sx={{ bgcolor: 'background.default' }}>
                                    <CardContent>
                                        <Typography variant="body1" fontWeight={600} noWrap>
                                            {h.uebung_name}
                                        </Typography>
                                        <Typography variant="caption" color="text.secondary">
                                            {h.zielmuskel}
                                        </Typography>
                                        <Box display="flex" justifyContent="space-between" alignItems="center" mt={2}>
                                            <Typography variant="body2" color="text.secondary">
                                                {h.vname} {h.nname}
                                            </Typography>
                                            <Chip
                                                label={`${h.max_gewicht}kg`}
                                                color="secondary"
                                                size="small"
                                                sx={{ fontWeight: 700 }}
                                            />
                                        </Box>
                                    </CardContent>
                                </Card>
                            </Grid>
                        ))}
                    </Grid>
                ) : (
                    <Typography color="text.secondary" align="center" sx={{ py: 3 }}>
                        Noch keine Highscores
                    </Typography>
                )}
            </CardContent>
        </Card>
    );
}

export default StatistikenTab;
